import React from "react";

const OnBibleLogo = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="118"
		height="34"
		viewBox="0 0 118 34"
		fill="none"
		data-testid="onbible-logo"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M44.9591 23.8918C45.7304 24.1942 46.5564 24.3633 47.4334 24.402V24.417H47.8279C48.8543 24.417 49.8108 24.2455 50.6968 23.8982C51.5789 23.5525 52.3496 23.0636 53.0048 22.4326C53.6593 21.8022 54.1693 21.0617 54.5356 20.2182C54.905 19.3657 55.0872 18.4383 55.0872 17.4365C55.0872 16.4348 54.9051 15.5057 54.5355 14.6545C54.1691 13.8091 53.6591 13.0705 53.0048 12.4403C52.3496 11.8094 51.5789 11.3205 50.6968 10.9748C49.8108 10.6275 48.8526 10.456 47.8279 10.456C46.8033 10.456 45.8451 10.6275 44.9591 10.9748C44.0766 11.3207 43.3044 11.8113 42.643 12.4483C41.982 13.085 41.4715 13.8275 41.1113 14.6729C40.7491 15.5228 40.5703 16.4446 40.5703 17.4333C40.5703 18.4221 40.7491 19.3438 41.1113 20.1937C41.4715 21.0391 41.982 21.7816 42.643 22.4183C43.3031 23.0557 44.0771 23.5461 44.9591 23.8918ZM47.8279 12.1137C47.0304 12.1137 46.3009 12.2475 45.6353 12.5121C44.9649 12.7786 44.3838 13.1516 43.8891 13.6338L43.8887 13.6343C43.3922 14.1167 43.0063 14.6765 42.7309 15.3161C42.4586 15.9469 42.3199 16.652 42.3199 17.4317C42.3199 18.2101 42.458 18.8997 42.7313 19.5387C43.007 20.1836 43.3915 20.746 43.8887 21.2292C44.3839 21.7104 44.9654 22.085 45.6353 22.3513C46.3009 22.6159 47.0304 22.7498 47.8279 22.7498C48.6255 22.7498 49.3549 22.6159 50.0206 22.3513C50.6905 22.085 51.2678 21.7124 51.7554 21.2313C52.2459 20.7473 52.6292 20.1856 52.9051 19.539C53.1782 18.9003 53.3165 18.1993 53.3165 17.4317C53.3165 16.6634 53.1765 15.9472 52.9055 15.3159C52.6294 14.6764 52.2476 14.1163 51.7558 13.6326C51.2661 13.1509 50.6902 12.7783 50.0206 12.5121C49.3549 12.2475 48.6255 12.1137 47.8279 12.1137Z"
			fill="#5172EA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M59.062 18.9166C59.062 18.1865 59.1997 17.5866 59.4589 17.099C59.7179 16.6117 60.0919 16.2345 60.5915 15.9621C61.0895 15.6905 61.6884 15.5473 62.4014 15.5473C63.3305 15.5473 64.0011 15.808 64.4684 16.2823C64.9319 16.7528 65.1942 17.467 65.1942 18.4903V24.4669H66.9261V18.4155C66.9261 17.4665 66.7509 16.6401 66.3784 15.9553C66.0085 15.2752 65.4855 14.7606 64.8153 14.4194C64.1527 14.082 63.3871 13.9215 62.534 13.9215H62.5324C61.4688 13.9215 60.5423 14.154 59.7753 14.6416C59.4968 14.8187 59.2465 15.0206 59.0248 15.2466V13.9962H57.3301V24.4669H59.062V18.9166Z"
			fill="#5172EA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M69.7932 10.695H76.3716C77.9964 10.695 79.3015 11.007 80.2267 11.69C81.1563 12.3763 81.6321 13.313 81.6321 14.4652C81.6321 15.2206 81.4531 15.8922 81.0755 16.4552C80.8756 16.754 80.6389 17.0155 80.3666 17.2394C80.9228 17.528 81.3786 17.9265 81.7252 18.4347C82.1252 19.0212 82.3129 19.7333 82.3129 20.5485C82.3129 21.7827 81.8234 22.7708 80.8471 23.4661C79.8841 24.1518 78.4992 24.4667 76.7533 24.4667H69.7932V10.695ZM73.0338 16.1642H76.108C76.9274 16.1642 77.496 16.0209 77.8627 15.7825L77.8632 15.7822C78.1997 15.5642 78.3721 15.2512 78.3721 14.7786C78.3721 14.3 78.1952 13.9699 77.864 13.7565L77.8632 13.756C77.4945 13.5172 76.9254 13.374 76.108 13.374H73.0338V16.1642ZM73.0338 21.7861V18.8273H76.598C77.4801 18.8273 78.1007 18.9757 78.5021 19.223C78.8629 19.4467 79.0513 19.7715 79.0513 20.3067C79.0513 20.847 78.8591 21.1831 78.5053 21.398C78.1039 21.6417 77.4825 21.7861 76.598 21.7861H73.0338Z"
			fill="#5172EA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M85.4972 12.8938C84.97 12.8938 84.5044 12.7286 84.1393 12.3738C83.7812 12.0292 83.5955 11.5998 83.5955 11.1073C83.5955 10.6183 83.7804 10.1721 84.142 9.82856L84.1429 9.82776L84.1437 9.82698C84.5092 9.48386 84.9706 9.3208 85.4972 9.3208C86.0176 9.3208 86.4788 9.47362 86.844 9.80175C87.2121 10.1309 87.3989 10.5583 87.3989 11.05C87.3989 11.5592 87.2213 12.0024 86.8687 12.3573C86.6489 12.5786 86.3892 12.7276 86.0984 12.8107L85.4972 12.8938Z"
			fill="#5172EA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M87.0593 13.7369H83.9141V24.4303H87.0593V13.7369Z"
			fill="#5172EA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M92.5092 9.87758H89.364V24.4303H92.396V23.6473C92.5445 23.7592 92.7011 23.861 92.8657 23.9526C93.5972 24.3596 94.4247 24.5592 95.3393 24.5592C96.3338 24.4918 97.2705 24.3666 98.1601 23.8676C98.9811 23.4071 99.6347 22.7674 100.116 21.9539C100.604 21.1293 100.841 20.1665 100.841 19.082C100.841 17.9975 100.604 17.0347 100.116 16.2101C99.6346 15.3964 98.9804 14.7576 98.1579 14.3031C97.3315 13.8465 96.3876 13.6239 95.3376 13.6239C94.4581 13.6239 93.649 13.8212 92.9149 14.2188C92.774 14.2951 92.6387 14.3788 92.5092 14.4698V9.87758ZM92.8161 17.6188C93.0466 17.2166 93.3521 16.9149 93.7385 16.703C94.1262 16.4912 94.5694 16.3808 95.0757 16.3808C95.582 16.3808 96.0213 16.4912 96.4034 16.7023C96.7834 16.9123 97.0879 17.2142 97.317 17.618C97.5402 18.01 97.6615 18.5044 97.6615 19.082C97.6615 19.6573 97.5412 20.1389 97.3159 20.54C97.086 20.9493 96.7816 21.2543 96.4034 21.4633C96.0213 21.6743 95.582 21.7847 95.0757 21.7847C94.5703 21.7847 94.1273 21.6756 93.7387 21.4626L93.7378 21.4621C93.3533 21.2528 93.0468 20.9479 92.8177 20.54C92.5919 20.1364 92.472 19.6671 92.472 19.082C92.472 18.4944 92.5929 18.0111 92.8161 17.6188Z"
			fill="#5172EA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M102.299 9.85854H105.444V24.4097H102.299V9.85854Z"
			fill="#5172EA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M117.889 17.7682C117.776 17.1684 117.577 16.6153 117.288 16.1115C116.812 15.2825 116.156 14.637 115.325 14.1817C114.493 13.7268 113.578 13.5032 112.514 13.5032C111.452 13.5032 110.489 13.7327 109.638 14.2012C108.791 14.6675 108.123 15.314 107.64 16.1367C107.153 16.9652 106.916 17.9236 106.916 18.9613C106.916 20.0026 107.162 20.9457 107.661 21.7793C108.159 22.6117 108.862 23.2638 109.758 23.7346C110.66 24.2084 111.702 24.4384 112.873 24.4384H112.875C113.796 24.4384 114.63 24.2935 115.371 23.9927C116.108 23.6927 116.73 23.2586 117.226 22.6903L117.454 22.4292L115.677 20.4186L115.38 20.7304C115.066 21.0612 114.713 21.2989 114.319 21.4499C113.92 21.6031 113.459 21.6831 112.933 21.6831C112.328 21.6831 111.812 21.5702 111.373 21.3532C110.933 21.1364 110.602 20.8352 110.367 20.4452L110.366 20.4445L110.366 20.4439C110.299 20.3337 110.241 20.2182 110.192 20.0971H117.924L117.96 19.7425C117.972 19.6259 117.983 19.5016 117.989 19.37C117.996 19.2408 118 19.1224 118 19.0154C118 18.5876 117.964 18.1786 117.892 17.7892L117.933 17.7682H117.889ZM110.142 17.7682H114.891C114.843 17.6166 114.78 17.4744 114.702 17.3412C114.485 16.9677 114.193 16.6777 113.822 16.4662C113.455 16.2576 113.024 16.1472 112.518 16.1472C112.009 16.1472 111.561 16.2584 111.195 16.4658C110.824 16.6785 110.535 16.9688 110.325 17.3453C110.251 17.4763 110.19 17.617 110.142 17.7682Z"
			fill="#5172EA"
		/>
		<path
			d="M18.0542 10.0241L17.7917 9.76159H15.8494V12.9638H12.7523V15.1686H15.8494V24.1454H18.0542V15.1686H21.1513V13.1738L20.8889 12.9638H18.0542V10.0241Z"
			fill="url(#paint0_linear_15106_9656)"
		/>
		<path
			d="M17.7917 12.9638H20.8889V14.9062H17.7917V24.1454H15.8494V14.9062H12.7523V12.9638H15.8494V9.76159H17.7917V12.9638Z"
			fill="url(#paint1_linear_15106_9656)"
		/>
		<path
			d="M17.7917 12.9638H20.8889V14.9062H17.7917V24.1454H15.8494V14.9062H12.7523V12.9638H15.8494V9.76159H17.7917V12.9638Z"
			fill="url(#paint2_linear_15106_9656)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.4111 8.52506C19.9835 3.09733 11.9264 2.70153 7.39647 7.23158C2.86655 11.7616 3.26234 19.819 8.68991 25.2467C14.1175 30.6745 22.1746 31.0703 26.7046 26.5402C31.2345 22.0102 30.8387 13.9528 25.4111 8.52506ZM5.05222 4.88726C7.89929 2.04011 11.7081 0.744377 15.6217 0.886413C19.8718 1.04066 24.2455 2.89058 27.6455 6.29062C30.9112 9.55644 32.7468 13.7207 33.0234 17.8109C33.2998 21.9002 32.0179 25.9153 29.0488 28.8845C23.1099 34.8237 12.9862 34.0121 6.45554 27.4812C-0.0751389 20.9503 -0.886729 10.8264 5.05222 4.88726Z"
			fill="url(#paint3_linear_15106_9656)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.31527 16.9686C3.31527 9.42815 9.42787 3.31537 16.9682 3.31537C24.5084 3.31537 30.621 9.42815 30.621 16.9686C30.621 24.5091 24.5084 30.6219 16.9682 30.6219C9.42787 30.6219 3.31527 24.5091 3.31527 16.9686ZM16.9682 0C7.5969 0 0 7.59712 0 16.9686C0 26.3402 7.5969 33.9373 16.9682 33.9373C21.7617 33.9373 26.091 31.9495 29.1767 28.7533C32.1236 25.7009 33.9363 21.5465 33.9363 16.9686C33.9363 12.2963 32.048 8.06508 28.9929 4.99648C32.3629 8.41405 33.686 13.1481 33.0234 17.8109C32.7468 13.7207 30.9112 9.55644 27.6455 6.29062C24.2455 2.89058 19.8718 1.04066 15.6217 0.886413C20.1876 0.121662 24.8613 1.26373 28.3355 4.37041C25.327 1.65396 21.3407 0 16.9682 0Z"
			fill="url(#paint4_linear_15106_9656)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.6217 0.886413C19.8718 1.04066 24.2455 2.89058 27.6455 6.29062C30.9112 9.55644 32.7468 13.7207 33.0234 17.8109C32.5082 21.4363 30.7926 25.0187 27.9056 27.9059C24.6686 31.1429 20.5578 32.9073 16.4922 33.1582C12.2847 33.418 8.12562 32.0567 5.03391 29.0296C4.79657 28.7948 4.56615 28.553 4.34293 28.3046C-1.10362 22.1776 -0.466102 12.3472 5.94062 5.94032C8.71784 3.16302 12.1384 1.46983 15.6217 0.886413ZM28.9929 4.99648C28.9691 4.97241 28.9453 4.94841 28.9214 4.92448C28.8788 4.88191 28.836 4.83971 28.793 4.79779C28.7123 4.71931 28.6308 4.64162 28.5485 4.56475C28.478 4.49914 28.407 4.43436 28.3355 4.37041C28.5602 4.57326 28.7794 4.78203 28.9929 4.99648ZM3.31514 16.9671C3.31514 9.42665 9.42774 3.31387 16.968 3.31387C20.5097 3.31387 23.7364 4.66252 26.1627 6.87427C26.271 6.97238 26.3777 7.07291 26.483 7.17581C29.0352 9.65661 30.6209 13.1267 30.6209 16.9671C30.6209 24.5076 24.5083 30.6204 16.968 30.6204C13.2245 30.6204 9.83282 29.1137 7.36638 26.6736C7.3338 26.6417 7.30134 26.6097 7.26905 26.5774C7.07144 26.3798 6.88244 26.1766 6.702 25.9682C4.59344 23.5652 3.31514 20.4154 3.31514 16.9671Z"
			fill="url(#paint5_linear_15106_9656)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.6455 6.29062C24.2455 2.89058 19.8718 1.04066 15.6217 0.886413C20.1876 0.121662 24.8613 1.26373 28.3355 4.37041C28.5602 4.57326 28.7794 4.78203 28.9929 4.99648C32.3629 8.41405 33.686 13.1481 33.0234 17.8109C32.7468 13.7207 30.9112 9.55644 27.6455 6.29062Z"
			fill="url(#paint6_linear_15106_9656)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_15106_9656"
				x1="32.2787"
				y1="6.1485"
				x2="1.65713"
				y2="25.4672"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.31" stopColor="#5172EA" />
				<stop offset="1" stopColor="#B9C8FF" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_15106_9656"
				x1="32.8758"
				y1="4.97702"
				x2="-0.586665"
				y2="25.4283"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#646464" />
				<stop offset="1" stopColor="#111111" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_15106_9656"
				x1="31.27"
				y1="6.1485"
				x2="1.07648"
				y2="24.6019"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B9C8FF" />
				<stop offset="1" stopColor="#5172EA" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_15106_9656"
				x1="32.2787"
				y1="6.1485"
				x2="1.65713"
				y2="25.4672"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.17" stopColor="#5172EA" />
				<stop offset="1" stopColor="#B9C8FF" />
			</linearGradient>
			<linearGradient
				id="paint4_linear_15106_9656"
				x1="4.79207"
				y1="2.32076"
				x2="32.822"
				y2="29.4758"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B9C8FF" />
				<stop offset="1" stopColor="#5172EA" />
			</linearGradient>
			<linearGradient
				id="paint5_linear_15106_9656"
				x1="32.2786"
				y1="6.14797"
				x2="1.65707"
				y2="25.4667"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B9C8FF" />
				<stop offset="1" stopColor="#5172EA" />
			</linearGradient>
			<linearGradient
				id="paint6_linear_15106_9656"
				x1="32.2786"
				y1="6.14797"
				x2="1.65707"
				y2="25.4667"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B9C8FF" />
				<stop offset="1" stopColor="#5172EA" />
			</linearGradient>
		</defs>
	</svg>
);

export default OnBibleLogo;
